export const LOGIN_PAYSERVER = 'LOGIN';
 

export const payserverLogin = ({token,expiredAt}) => dispatch =>
  dispatch({
    type: LOGIN_PAYSERVER,
    token:token,
    expiredAt:expiredAt,
  });
 